var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiraxisSupply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 469,
    height: 62,
    viewBox: "0 0 469 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3288_130903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.477 16.3359L117.265 45.6817H129.693L132.561 37.7137H137.17L129.477 16.3359Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.814 45.6836H165.386L147.285 2.34375H137.209L152.814 45.6836Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.99219V45.6117H11.476V23.1669L21.854 31.4728V17.7109L1.64892 1.99219H0Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2478 1.99219L28.1865 17.6933V31.4456L38.4839 23.104V45.6117H49.9596V1.99219H48.2478Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.427 44.0512V33.6529C239.573 35.2452 243.339 36.4207 246.919 36.7272C248.153 36.8372 249.33 36.8372 250.442 36.7763C254.08 36.5433 256.119 35.6004 256.119 33.8238C256.119 31.5828 253.338 30.4556 247.91 28.4959C240.436 25.789 235.622 22.8247 235.622 15.0225C235.622 7.22027 242.354 2.125 252.475 2.125C256.918 2.125 261.368 2.95791 264.328 4.14598V14.1409C261.675 12.5363 257.474 11.4704 253.401 11.4704C249.329 11.4704 246.733 12.8302 246.733 14.9616C246.733 16.97 249.329 18.3297 254.514 20.3385C261.982 23.1799 267.109 26.1932 267.109 33.7625C267.109 41.626 260.933 46.3661 249.886 46.3661C244.822 46.3665 239.759 45.411 236.427 44.0512Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4111 2.71094H57.875V45.6685H69.4111V2.71094Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.363 2.71094H216.827V45.6685H228.363V2.71094Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.685 38.9215L106.393 28.1413C107.158 28.014 107.923 27.8859 108.688 27.6313C113.787 26.1015 117.866 22.2135 117.866 15.7125C117.866 7.49072 111.301 2.71094 101.677 2.71094H77.3301V45.6681H88.8662V30.5626V29.5435V21.1936V17.8156V11.3146H100.147C104.099 11.3146 106.075 13.4177 106.075 16.0312C106.075 19.2815 103.971 21.1936 99.9561 21.1936H95.0215V29.7112L104.545 45.6677H110.908L113.685 38.9215Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.368 12.0493L179.991 2.71094H165.714L181.202 23.9984L169.472 40.2102L171.758 45.6685H179.545L186.169 36.4653L186.368 12.0493Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.136 23.9992L212.687 2.71094H198.602L192.121 12.0363L192.121 36.5069L198.474 45.6689H212.751L197.136 23.9992Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.814 45.6914L137.208 2.35156L135.224 2.37514L132.851 8.21491L146.967 45.6914H152.814Z",
    fill: "#B4C5C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.565 46.1747C283.943 46.1747 278.929 41.1616 278.438 35.1698H281.312C281.804 38.7183 284.496 43.7923 292.565 43.7923C299.044 43.7923 303.018 39.8792 303.018 34.9875C303.018 21.1082 279.051 29.7916 279.051 13.4639C279.051 7.35069 284.186 2.39844 292.195 2.39844C300.271 2.39844 304.671 7.102 305.527 12.121H302.592C301.979 9.12494 298.861 4.78047 292.134 4.78047C286.513 4.71997 281.804 7.95887 281.804 13.4034C281.804 27.2823 305.77 18.7812 305.77 34.9266C305.77 40.4324 301.37 46.1747 292.565 46.1747Z",
    fill: "#902F57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.749 45.7496H336.996V38.5367C335.1 43.7325 330.269 46.3028 324.831 46.3028C317.429 46.3028 311.377 41.8974 311.377 31.8707V12.5469H314.069V31.688C314.069 39.8187 318.53 43.9145 325.195 43.9145C332.105 43.9145 336.996 39.5755 336.996 30.3393V12.5469H339.749V45.7496Z",
    fill: "#902F57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.917 12.1172C375.214 12.1172 381.941 18.5954 381.941 29.114C381.941 39.5721 375.214 46.2318 365.917 46.2318C358.643 46.2318 353.69 42.0755 351.855 37.062V61.3989H349.103V12.5431H351.855V21.287C353.63 16.213 358.643 12.1172 365.917 12.1172ZM365.491 14.4996C357.786 14.4996 351.855 20.2478 351.855 29.114C351.855 38.1011 357.786 43.7888 365.491 43.7888C373.561 43.7888 379.127 38.2838 379.127 29.114C379.127 19.9442 373.561 14.4996 365.491 14.4996Z",
    fill: "#902F57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.428 12.1172C414.725 12.1172 421.452 18.5954 421.452 29.114C421.452 39.5721 414.725 46.2318 405.428 46.2318C398.154 46.2318 393.201 42.0755 391.366 37.062V61.3989H388.614V12.5431H391.366V21.287C393.141 16.213 398.154 12.1172 405.428 12.1172ZM405.002 14.4996C397.298 14.4996 391.366 20.2478 391.366 29.114C391.366 38.1011 397.298 43.7888 405.002 43.7888C413.072 43.7888 418.638 38.2838 418.638 29.114C418.638 19.9442 413.073 14.4996 405.002 14.4996Z",
    fill: "#902F57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.031 0.5H429.279V45.7469H432.031V0.5Z",
    fill: "#902F57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.853 12.5469H468.666L449.343 61.3422H446.53L452.704 45.7496L438.764 12.5469H441.76L454.235 42.6934L465.853 12.5469Z",
    fill: "#902F57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3288_130903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 468.667,
    height: 60.9,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiraxisSupply);
export default __webpack_public_path__ + "static/media/miraxis-supply.a11c743983840a7b9a0513500279729f.svg";
export { ForwardRef as ReactComponent };